// No-flash theme bootstrap. Resolves preference (light/dark/auto) into
// `data-bs-theme` on <html> before CSS paints. Bootstrap 5.3 reads
// this attribute to switch component colors automatically.
//
// Loaded synchronously in <head> (no defer/async) — must run before paint
// to avoid flash of wrong theme. Kept out of app.js so the large app
// bundle stays free to be deferred in the future without breaking theme.
(function () {
  var root = document.documentElement;
  var pref = root.getAttribute('data-theme-pref') || 'auto';
  var systemDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  var theme = pref === 'auto' ? (systemDark ? 'dark' : 'light') : pref;
  root.setAttribute('data-bs-theme', theme);
  if (window.matchMedia) {
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', function (e) {
      if (root.getAttribute('data-theme-pref') === 'auto') {
        root.setAttribute('data-bs-theme', e.matches ? 'dark' : 'light');
      }
    });
  }
})();
